export default class Abstract {
    id: number;
    abstractNumber: string;
    section: string;
    legal: string;
    county: string;
    name: string;
    acres: number;
}



// WEBPACK FOOTER //
// ./src/models/Abstract.ts